var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { baseCommon, configCommon, merchantCommon, } from '@repo/api/endpoints/merchant/msw/mocks/common';
export var NO_DEFAULT_PROVIDER_LOAN_APPLICATION_POSSIBLE_WITH_SELECTED_MARKETING_DATA = __assign(__assign({}, baseCommon), { type: 'IFRAME_MERCHANT_SUMMARY', currentProvider: ['liberis', 'pragma'], data: {
        merchantData: __assign(__assign({}, merchantCommon), { user: {
                type: 'user',
                userId: 12345,
                permission: {
                    widget: true,
                    newLoan: true,
                    cancelLoan: true,
                    continueLoan: true,
                },
                accessFor: ['193421', '1234', '4321'],
            } }),
        preLimits: [
            {
                id: 12345,
                min: 3000,
                max: 50000,
                currency: 'PLN',
                provider: 'liberis',
                availableLimitRevenueRate: [
                    {
                        period: 12,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                    {
                        period: 6,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                ],
            },
            {
                id: 123452,
                min: 3000,
                max: 40000,
                currency: 'PLN',
                provider: 'pragma',
                availableLimitRevenueRate: [
                    {
                        period: 12,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                    {
                        period: 6,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                ],
            },
        ],
        limits: [],
        loans: [],
        agreements: {
            marketing: [
                {
                    provider: 'liberis',
                    accepted: true,
                    timestamp: '2024-05-16T07:38:18.593Z',
                },
                {
                    provider: 'pragma',
                    accepted: true,
                    timestamp: '2024-05-16T07:38:18.593Z',
                },
            ],
        },
        transfers: [],
        offers: [],
    }, config: [
        __assign(__assign({}, configCommon[0]), { provider: 'liberis', default: false }),
        __assign(__assign({}, configCommon[0]), { provider: 'pragma', default: false }),
    ] });
